import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';

interface ProtectedRouteProps {
  element: React.ReactNode;
  featureFlag: string;
  fallback?: React.ReactNode;
}

/**
 * A component that renders children only if the specified feature flag is enabled.
 * Otherwise, it renders a fallback component or a default "not accessible" message.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  featureFlag,
  fallback,
}) => {
  const { hasFeature } = useFeatureFlags();

  if (hasFeature(featureFlag)) {
    return <>{element}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '70vh',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h4" gutterBottom>
        This page is not accessible :-(
      </Typography>
      <Typography variant="body1" color="text.secondary">
        You don't have permission to view this section.
      </Typography>
    </Box>
  );
};

export default ProtectedRoute;
